import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { Subscription } from "rxjs";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { MessageServiceService } from "src/app/services/message-service.service";
import { compareAsc } from "date-fns";
import { NavigationEnd, Router, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";
@Component({
  selector: "app-call-appointment-history",
  templateUrl: "./call-appointment-history.component.html",
  styleUrls: ["./call-appointment-history.component.scss"],
})
export class CallAppointmentHistoryComponent implements OnInit, OnDestroy {
  //popup
  displayPopup: boolean = false;
  confirmModalRef: BsModalRef;
  @ViewChild("confirmTemplate", { static: false })
  confirmTemplate: TemplateRef<any>;
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
  };

  modalTitle;
  selectedApptDetails;
  isRescheduleApptOpen: boolean = false;
  isCancelApptPopupOpen: boolean = false;
  isFromReports: boolean = false;
  callType;
  leadId;
  isNewUser;
  CallerStatusAutoId;
  tabItems: any;
  activeItem: any;
  patientName: string;
  mobileNumber: string;
  patientEmail;
  string;
  patientMobile: string; //9491898828, 9493888651
  patientUHIDMobile: string = "";
  showBasicDetailsTable: boolean = true;
  showAppointmentHistory: boolean = true;
  showCallHistory: boolean = false;
  showHCAppointmentHistory: boolean = false;
  showCorpHCAppointmentHistory: boolean = false;
  showITDoseAppointmentHistory: boolean = false;
  selectedCurrentState$: Subscription;
  selectedViewHistory$: Subscription;

  constructor(
    private callCenterService: CallCenterService,
    private askApolloService: AskApolloService,
    private messageService: MessageServiceService,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router
  ) {
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        console.log("prev:", event.url);
      });

    this.route.queryParamMap.subscribe((param) => {
      this.mobileNumber = param.get("mobile");
      this.isFromReports = param.get("isReport") == "true";
      if (this.isFromReports) {
        this.getAppointmentsHistoryOnMobileNumber(this.mobileNumber);
      } else {
        //this method get the selected uhid data from service
        this.selectedViewHistory$ =
          this.callCenterService.selectedViewHistory.subscribe((value) => {
            if (
              value.isRequestFormPopUp &&
              value.CallerMobileNumber &&
              value.CallerMobileNumber.length == 10
            ) {
              this.showBasicDetailsTable = false;
              this.leadId = value.leadId;
              this.callType = value.callType;
              this.CallerStatusAutoId = value.CallerStatusAutoId;
              this.patientEmail = value.PatientDetails["emailId"];
              this.patientMobile = value.CallerMobileNumber; //value.isNewUser ? value.PatientDetails["phoneNo"] :  value.PatientDetails["mobileNumber"] ;
              this.patientUHIDMobile = value.UHIDMobileNumber; //value.isNewUser ? value.PatientDetails["phoneNo"] :  value.PatientDetails["mobileNumber"] ;
              this.patientName =
                value.PatientDetails["firstName"] +
                " " +
                value.PatientDetails["lastName"];
              this.getCallHistoryOnMobileNumber(this.patientMobile);
              this.getAppointmentsHistoryOnMobileNumber(this.patientUHIDMobile);
            } else {
              this.showBasicDetailsTable = true;
              this.getCallHistoryOnMobileNumber(this.mobileNumber);
              this.getAppointmentsHistoryOnMobileNumber(this.mobileNumber);
            }
          });

        //this method get the status of operation done in any child tab like appt book, call status updating, reschedule etc.
        //  this.selectedCurrentState$ = this.callCenterService.selectedCurrentState.subscribe(value => {
        //   if(value && value.isOperationDone){
        //       //this.closeConfirmModal();
        //       this.getAppointmentsHistoryOnMobileNumber(this.patientUHIDMobile || this.mobileNumber);
        //       this.getCallHistoryOnMobileNumber(this.patientMobile || this.mobileNumber);
        //     }
        // });
      }
    });
  }

  ngOnInit() {
    if (this.isFromReports) {
      this.tabItems = [
        { label: "Appointment History", icon: "fa pi-fw  fa-calendar-check-o" },
        { label: "Call History", icon: "fa pi-fw fa-phone" },
      ];
    } else {
      this.tabItems = [
        { label: "Appointment History", icon: "fa pi-fw  fa-calendar-check-o" },
        { label: "Call History", icon: "fa pi-fw fa-phone" },
        { label: "Corp HC Appointment History", icon: "fa pi-fw fa-phone" },
        { label: "IT Dose Appointment History", icon: "fa pi-fw fa-phone" },
        { label: "HC Appointment History", icon: "fa pi-fw fa-phone" },
      ];
    }

    this.activeItem = this.tabItems[0];
    this.showAppointmentHistory = true;
  }

  ngOnDestroy(): void {
    // this.selectedCurrentState$.unsubscribe();
    if (this.selectedViewHistory$) {
      this.selectedViewHistory$.unsubscribe();
    }
  }

  currentTab(index) {
    if (index == 0) {
      //clinic appt history
      this.showAppointmentHistory = true;
      this.showCallHistory = false;
      this.showHCAppointmentHistory = false;
      this.showCorpHCAppointmentHistory = false;
      this.showITDoseAppointmentHistory = false;
      this.getAppointmentsHistoryOnMobileNumber(
        this.patientMobile || this.mobileNumber
      );
    } else if (index == 1) {
      //call history
      this.showCallHistory = true;
      this.showAppointmentHistory = false;
      this.showHCAppointmentHistory = false;
      this.showCorpHCAppointmentHistory = false;
      this.showITDoseAppointmentHistory = false;
      this.getCallHistoryOnMobileNumber(
        this.patientMobile || this.mobileNumber
      );
    } else if (index == 2) {
      // ask apollo Corp health check appt history
      this.showCorpHCAppointmentHistory = true;
      this.showHCAppointmentHistory = false;
      this.showCallHistory = false;
      this.showAppointmentHistory = false;
      this.showITDoseAppointmentHistory = false;
    } else if (index == 3) {
      // IT Dose appt history
      this.showITDoseAppointmentHistory = true;
      this.showCorpHCAppointmentHistory = false;
      this.showHCAppointmentHistory = false;
      this.showCallHistory = false;
      this.showAppointmentHistory = false;
    } else {
      // ask apollo health check appt history
      this.showHCAppointmentHistory = true;
      this.showCallHistory = false;
      this.showAppointmentHistory = false;
      this.showCorpHCAppointmentHistory = false;
      this.showITDoseAppointmentHistory = false;
      localStorage.setItem(
        "currentCallerStatusAutoId",
        this.CallerStatusAutoId
      );
    }
  }

  callHistory = [];
  getCallHistoryOnMobileNumber(mobileNo) {
    this.callHistory = [];
    let payload = {
      MobileNumber: mobileNo,
    };
    this.callHistoryIsLoading = true;
    this.callCenterService.getCallHistory(payload).subscribe(
      (res: any) => {
        if (res && res.response && res.isSuccess) {
          this.callHistory = res.response;
        }
        this.callHistoryIsLoading = false;
      },
      (error) => {
        this.callHistoryIsLoading = false;
        this.messageService.showErrorMessage(
          "Unable to retrieve call history data from server "
        );
      }
    );
  }
  parseAppointmentDate(dateStr: string): Date {
    if (!dateStr) return new Date(0); // fallback to epoch if date is invalid
    const parts = dateStr.split("-");
    return new Date(+parts[2], +parts[1] - 1, +parts[0]); // YYYY, MM-1, DD
  }

  appointmentsHistory = [];
  isLoading: boolean = false;
  callHistoryIsLoading: boolean = false;

  getAppointmentsHistoryOnMobileNumber(mobileNo) {
    debugger;
    this.appointmentsHistory = [];
    let payload = {
      MobileNumber: mobileNo, //'9491898828'
    };
    this.isLoading = true;
    this.askApolloService
      .getAppointmentsHistoryOnMobileNumberFromAskApollo(payload)
      .subscribe(
        (res: any) => {
          debugger;
          localStorage.setItem(
            "AppointmentInformation1",
            JSON.stringify(res.response)
          );
          console.log("appointmnets", res);
          if (res.isSuccess) {
            let upcoming = res.response.UpcomingAppointments || [];
            let past = res.response.PastAppointments || [];

            const upcomingSorted =
              res.response.UpcomingAppointments !== null &&
              res.response.UpcomingAppointments.length > 0
                ? res.response["UpcomingAppointments"].sort((a, b) => {
                    const aCancelled = !!a.cancelledOn;
                    const bCancelled = !!b.cancelledOn;

                    // If one is cancelled and the other is not, move cancelled to end
                    if (aCancelled && !bCancelled) return 1;
                    if (!aCancelled && bCancelled) return -1;

                    // If both are either cancelled or not, sort by createdOn descending
                    const aTime = new Date(
                      a.createdOn.split("-").reverse().join("-")
                    ).getTime();
                    const bTime = new Date(
                      b.createdOn.split("-").reverse().join("-")
                    ).getTime();
                    return bTime - aTime;
                  })
                : [];

            const pastSorted = (res.response.PastAppointments || []).sort(
              (a, b) =>
                this.parseAppointmentDate(b.appointmentDate).getTime() -
                this.parseAppointmentDate(a.appointmentDate).getTime()
            );

            this.appointmentsHistory["currentAppointments"] = upcomingSorted;
            this.appointmentsHistory["previousAppointments"] = pastSorted;
          }
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.messageService.showErrorMessage(
            "Unable to retrieve appointment history data from server "
          );
        }
      );
  }

  getAppointmentsHistoryOnMobileNumberFromCRMDb(mobileNo) {
    debugger;

    this.appointmentsHistory = [];
    let payload = {
      MobileNumber: mobileNo,
    };
    this.isLoading = true;
    this.askApolloService
      .getAppointmentsHistoryOnMobileNumber(payload)
      .subscribe(
        (res: any) => {
          if (res.isSuccess) {
            let tempObj = res.response;
            //this.appointmentsHistory = res.response;
            //5/30/2020 12:00:00 AM
            let previousAppts = [];
            let currentAppts = [];
            tempObj.forEach(function (appt) {
              let date = new Date();
              date.setDate(date.getDate() - 1);
              let arr = [];
              if (appt["appointmentDate"].includes("/"))
                arr = appt["appointmentDate"].split("/"); //mm/dd/yyyy
              else arr = appt["appointmentDate"].split("-"); //dd/mm/yyyy
              let apptDate = null;
              if (appt["appointmentDate"].includes("/"))
                apptDate = new Date(
                  arr[2].split(" ")[0],
                  arr[0],
                  arr[1],
                  0,
                  0,
                  0,
                  0
                );
              //yyyy,mm,dd,hh,mm,ss
              else
                apptDate = new Date(
                  arr[2].split(" ")[0],
                  arr[1],
                  arr[0],
                  0,
                  0,
                  0,
                  0
                ); //yyyy,mm,dd,hh,mm,ss
              if (compareAsc(new Date(apptDate), date) > 0) {
                currentAppts.push(appt);
              } else {
                previousAppts.push(appt);
              }
            });
            this.appointmentsHistory["currentAppointments"] = currentAppts;
            this.appointmentsHistory["previousAppointments"] = previousAppts;
          }
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.messageService.showErrorMessage(
            "Unable to retrieve appointment history data from server "
          );
        }
      );
  }

  showModalDialog(apptDetails, type) {
    debugger;
    this.confirmModalRef = this.modalService.show(
      this.confirmTemplate,
      Object.assign({}, this.config, {
        class: "gray modal-sm modal-dialog-centered",
      })
    );
    let callStatusObj;
    this.selectedApptDetails = apptDetails;
    if (type == "cancel") {
      callStatusObj =
        this.callType == 1
          ? { callCenterStatusId: 23, statusName: "Cancel Appointment" }
          : { callCenterStatusId: 23, statusName: "Cancel Appointment" };
      this.modalTitle = "Cancel Appointment";
      this.isCancelApptPopupOpen = true;
      this.isRescheduleApptOpen = false;
      this.callCenterService.ProceedToCancelAppt({
        CallTypeId: this.callType,
        CallStatus: callStatusObj,
        LeadId: this.leadId,
        IsNewUser: this.isNewUser,
        CallerStatusAutoId: this.CallerStatusAutoId,
        RescheduleDetails: this.selectedApptDetails,
      });
      //this.ref.detectChanges();
    } else {
      callStatusObj =
        this.callType == 1
          ? { callCenterStatusId: 16, statusName: "Rescheduling" }
          : { callCenterStatusId: 16, statusName: "Rescheduling" };
      this.modalTitle = "Reschedule Appointment";
      this.isRescheduleApptOpen = true;
      this.isCancelApptPopupOpen = false;
      this.callCenterService.ProceedToReschedule({
        CallTypeId: this.callType,
        CallStatus: callStatusObj,
        LeadId: this.leadId,
        IsNewUser: this.isNewUser,
        CallerStatusAutoId: this.CallerStatusAutoId,
        RescheduleDetails: this.selectedApptDetails,
      });
    }
  }

  closeConfirmModal() {
    this.getAppointmentsHistoryOnMobileNumber(this.mobileNumber);
    this.confirmModalRef.hide();
  }

  searchHistoryOnMobileNumber() {
    this.mobileNumber = this.mobileNumber + "";
    if (this.mobileNumber && this.mobileNumber.length == 10) {
      this.getCallHistoryOnMobileNumber(this.mobileNumber);
      this.getAppointmentsHistoryOnMobileNumber(this.mobileNumber);
    } else {
      this.messageService.showErrorMessage("Invalid Mobile Number");
    }
  }

  navigateToLeadsPage(pageName) {
    if (pageName == "leads") this.router.navigate(["/base/leads"]);
    else this.router.navigate(["/base/leads/activity-leads"]);
  }
  navigateToCallHistoryReports() {
    this.router.navigate(["/base/reports/callhistory-report"]);
  }
}
